Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lineTypePropType = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var lineTypes = {
  FULL: 'full',
  NONE: 'none'
};

var lineTypePropType = exports.lineTypePropType = _propTypes2['default'].oneOf(Object.values(lineTypes));
exports['default'] = lineTypes;


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/constants/lineTypes.js
// module id = 87
// module chunks = 923280921217 19843951674672